import { Action, Dispatch, bindActionCreators } from 'redux';
import { ClaimDetails, StateProps, DispatchProps } from '../components/claim/ClaimDetails';
import { generateClaim, refreshClaim, resetClaim, submitClaim } from '../redux/claim/actions';
import { onPageDidMount, onPageWillUnmount } from '../redux/core';

import { RootState } from '../redux/types';
import { connect } from 'react-redux';
import { fetchOneClaim } from '../redux/claim/actions';
import { setClaimStatus } from '../redux/ui/actions';
import { toast } from '../redux/message/actions';
import { withRouter } from '../util/Router';

export function mapStateToProps(state: RootState): StateProps {
  return {
    optionKeyDepressed: state.ui.optionKeyDepressed,
    claim: state.claimDetails.claim,
  };
}

export function mapDispatchToProps(dispatch: Dispatch<Action>): DispatchProps {
  return {
    actions: bindActionCreators(
      {
        toast,
        onPageDidMount,
        onPageWillUnmount,
        setClaimStatus,
        submitClaim,
        refreshClaim,
        resetClaim,
        generateClaim,
        fetchOneClaim,
      },
      dispatch
    ),
  };
}

export const ClaimDetailsContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(ClaimDetails));
